import events from './json/events';
import general from './json/generalIcons.json';
import map from './json/map';
import poi from './json/pointsOfInterest';
import tracking from './json/tracking';
import units from './json/units';

const Icons = { ...map, ...events, ...units, ...poi, ...general, ...tracking };
export default Icons;
